// ProtectedRoute.tsx
import { Navigate } from "react-router-dom";

export function VerifyPermission({ children }: { children: JSX.Element }) {
  const data = localStorage.getItem("1");
  if (data) {
    const parsedData = JSON.parse(data);
    if (
      parsedData.usuarioCliente.codigoPermissao === "adm001" ||
      parsedData.usuarioCliente.codigoPermissao === "adm002"
    ) {
      return children;
    }
  }
  return <Navigate to="/loadRedirect" replace />;
}
